import {useEffect} from 'react';

/**
 * 외부 클릭 감지 훅
 * @param ref - 참조할 요소
 * @param handler - 외부 클릭 시 실행할 핸들러
 * @public
 */
export const useOutSideRef = (ref: any, handler: () => void) => {
  useEffect(() => {
    const listener = (e: any) => {
      if (!ref.current || ref.current.contains(e.target)) {
        return;
      }
      handler();
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};
